<template>
  <div class="bi-table-container">
    <!-- 描述表格 -->
    <div class="table-section">
      <md-table>
        <table class="description-table">
          <thead>
            <tr>
              <th>名称</th>
              <th>类型</th>
              <th>描述</th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="(value, key) in mergedDescription" :key="key">
              <td>{{ key }}</td>
              <td>{{ getType(key) }}</td>
              <td>{{ value }}</td>
            </tr>
          </tbody>
        </table>
      </md-table>
    </div>

    <!-- 数值表格 -->
    <div class="table-section">
      <md-table>
        <table class="data-table">
          <thead>
            <tr>
              <th v-for="col in tableColumns" :key="col">{{ col }}</th>
            </tr>
          </thead>
          <tbody>
            <tr v-if="tableData.length === 0">
              <td :colspan="tableColumns.length" class="empty-data">
                暂无数据
              </td>
            </tr>
            <tr v-for="(row, index) in tableData" :key="index">
              <td v-for="col in tableColumns" :key="col">
                {{ formatValue(row[col], col) }}
              </td>
            </tr>
          </tbody>
        </table>
      </md-table>
    </div>
  </div>
</template>

<script>
import mdTable from "@/components/ai/components/mdTable.vue";
export default {
  name: "BiTable",
  props: {
    data: {
      type: Object,
      required: true,
    },
  },
  components: {
    mdTable,
  },
  computed: {
    // 合并维度和指标的描述
    mergedDescription() {
      const metric = this.data.metric || {};
      const dimensions = metric.dimensions || {};
      const metrics = metric.metrics || {};
      return { ...dimensions, ...metrics };
    },
    // 获取表格列
    tableColumns() {
      const metric = this.data.metric || {};
      const columns = metric.columns || {};
      return Object.keys(columns);
    },
    // 获取表格数据
    tableData() {
      return this.data.data || [];
    },
  },
  methods: {
    // 根据名称判断类型（维度或指标）
    getType(name) {
      const metric = this.data.metric || {};
      const dimensions = metric.dimensions || {};
      return dimensions.hasOwnProperty(name) ? "维度" : "指标";
    },
    // 格式化数值（处理金额等）
    formatValue(value, col) {
      if (typeof value === "number") {
        // 列名包含ID/id/Id的不进行格式化
        if (col && !/id/i.test(col)) {
          // 只有列名包含"金额"或"单价"才进行金额格式化
          if (col.includes("金额") || col.includes("单价")) {
            return `¥${value.toLocaleString("zh-CN", {
              minimumFractionDigits: 2,
            })}`;
          }
          return value.toLocaleString("zh-CN");
        }
      }
      return value;
    },
  },
};
</script>

<style lang="scss" scoped>
.bi-table-container {
  width: 100%;
}

.table-section {
  margin-bottom: 24px;

  &:last-child {
    margin-bottom: 10px;
  }
}

.data-table {
  .empty-data {
    text-align: center;
    padding: 40px 0;
    color: #999999;
  }
}
</style>